import styled, { css } from 'styled-components';

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "ErrorScreenstyles__Container", componentId: "sc-1dbqy0n-0" })(["padding:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;"],
({ theme }) => `${theme.spacers.L} ${theme.spacers.M}`);







export const Title = /*#__PURE__*/styled.h5.withConfig({ displayName: "ErrorScreenstyles__Title", componentId: "sc-1dbqy0n-1" })(["margin:0;", " text-align:center;line-height:24px;color:", ";padding-top:", ";cursor:default;"],

(props) => css(props.theme.typography.Paragraph),


(props) => props.theme.colors['Level 4'],
(props) => props.theme.spacers.XL);



export const Message = /*#__PURE__*/styled.p.withConfig({ displayName: "ErrorScreenstyles__Message", componentId: "sc-1dbqy0n-2" })(["margin:0;", " text-align:center;color:", ";padding:12px 0;cursor:default;"],

(props) => css(props.theme.typography.TinyParagraph),

(props) => props.theme.colors['Level 4']);




export const ContactButton = /*#__PURE__*/styled.button.attrs({ type: 'button' }).withConfig({ displayName: "ErrorScreenstyles__ContactButton", componentId: "sc-1dbqy0n-3" })(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;font:inherit;line-height:normal;appearance:none;&::-moz-focus-inner{border:0;padding:0;}:focus{outline-style:none;box-shadow:none;border:none;}", " color:", ";text-decoration:underline;:hover{cursor:pointer !important;color:", ";}"],





















(props) => css(props.theme.typography.TinyParagraph),
(props) => props.theme.colors['Level 4'],




(props) => props.theme.colors['Level 3']);